/* @ngInject */
class ProfileController {
  constructor(StorageService, docService) {
    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
  }

  showDoc = () => {
    const url =`${endPoints.baseUrl}/api/usr/v2/documents/terms/9`;
    docService.showDoc(url, true);
  };
}

export default ProfileController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/profile.controller.js
 **/